import React, { FunctionComponent } from 'react'
import { injectIntl, InjectedIntlProps } from 'react-intl'
import PencilIcon from 'src/assets/Icons/PencilIcon.svg';
import { gotoEventManager } from 'src/lib/navigate-to';

import locale from './locale'

const style = require('./EventManagerButton.css')

interface Props {
  eventId: Number;
  isAuthorized: boolean;
  slugParam: string;
  memberships: any;
}

export const EventManagerButtonComponent: FunctionComponent<Props & InjectedIntlProps> = ({
  eventId,
  isAuthorized,
  slugParam,
  memberships,
  intl: { formatMessage },
}) => {
  const goToEditor = () => {
    let page = '';
    if (isAuthorized) {
      page = 'overview'
    }
    else {
      memberships.nodes.forEach((membership) => {
        if (isPermissionForCurrentEvent(membership)) {
          if (membership.hasManagePermission) {
            page = 'overview'
          }
          else if (membership.hasEditPermission) {
            page = 'info/basics'
          }
          else if (membership.hasPromotePermission) {
            page = 'promote'
          }
        }
      })
    }
    
    gotoEventManager(slugParam, page)
  };

  const isPermissionForCurrentEvent = (membership) => (membership.allEvents || membership.eventIds.includes(eventId))

  const hasMembershipPermission = () => {
    for(let i = 0; i < memberships.totalCount; i++) {
      const membership = memberships.nodes[i]
      if (isPermissionForCurrentEvent(membership)) {
        if (membership.hasManagePermission || membership.hasEditPermission || membership.hasPromotePermission) return true
      }
    }
    return false
  }

  return (
    isAuthorized || hasMembershipPermission() ?
    <div className={style.editEventButton} onClick={goToEditor}>
        <PencilIcon className={style.icon} />
        {formatMessage(locale.eventManager)}
    </div>
    : null
  )
}

export const EventManagerButton = injectIntl(EventManagerButtonComponent)